var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcessesInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 15V6C22 4.34315 20.6569 3 19 3H11C9.34315 3 8 4.34315 8 6V18M22 15H11C9.34315 15 8 16.3431 8 18M22 15V18C22 19.6569 20.6569 21 19 21H11C9.34315 21 8 19.6569 8 18M12 7H18M12 11H15M2 7H5M3.5 21L4.2 20.0667C4.71929 19.3743 5 18.5321 5 17.6667V4.5C5 3.67157 4.32843 3 3.5 3C2.67157 3 2 3.67157 2 4.5V17.6667C2 18.5321 2.28071 19.3743 2.8 20.0667L3.5 21Z",
    stroke: "#53545C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessesInactive);
export default __webpack_public_path__ + "static/media/processes-inactive.dbf2d2a0b3ef7e36fcd45b139f491db0.svg";
export { ForwardRef as ReactComponent };